<template>
  <div
    :class="[
      'relative',
      'group/banner group/flow-line overflow-hidden',
      props.theme === 'dark' ? '**:text-white' : '**:text-gray-700',
      props.transparent ? 'bg-transparent' : 'bg-secondary',
      props.boxClass,
    ]"
  >
    <!-- 内容层 -->
    <div
      :class="[
        'relative z-1',
        { page_view: props.hasPadding },
        'flex flex-col justify-center lg:gap-6 gap-4',
        'hover:cursor-default',
        'items-center text-center',
        props.centered ? '' : 'lg:items-start lg:text-start',
      ]"
    >
      <!-- 模块标题 -->
      <InspiraTextReveal
        :duration="2"
        :delay="0.2"
        :stagger="0.1"
        class="lg:text-5xl text-3xl font-bold text-shadow-md uppercase"
      >
        {{ props.title }}
      </InspiraTextReveal>

      <!-- 分隔线 -->
      <Motion
        :initial="{ opacity: 0, width: 0 }"
        :while-in-view="{ opacity: 1, width: 120 }"
        :transition="{
          type: 'spring',
          stiffness: 20,
          damping: 10,
        }"
        :in-view-options="{
          once: true,
        }"
        :class="['h-2', 'bg_linear_to_l']"
      />

      <!-- 描述 -->
      <InspiraTextReveal
        v-if="props.desc"
        :duration="2"
        :delay="0.5"
        :stagger="0.1"
        class="lg:text-2xl text-lg font-semibold text-shadow-md"
      >
        {{ props.desc }}
      </InspiraTextReveal>

      <!-- 正文 -->
      <Motion
        as="p"
        v-if="props.content"
        :initial="{ opacity: 0, y: 20 }"
        :while-in-view="{ opacity: 1, y: 0 }"
        :transition="{
          type: 'spring',
          stiffness: 20,
          damping: 10,
        }"
        :in-view-options="{
          once: true,
        }"
        :class="['lg:text-xl text-md font-semibold text-shadow-md']"
      >
        <span :class="['flow_line']">
          {{ props.content }}
        </span>
      </Motion>
    </div>

    <!-- 背景图片层 -->
    <NuxtImg
      v-if="props.bgUrl"
      :src="props.bgUrl"
      :class="[
        'absolute top-0 left-0',
        'object-cover size-full group-hover/banner:scale-105',
        'transition-all duration-1000',
        'brightness-80',
      ]"
    />
  </div>
</template>

<script lang="ts" setup>
  interface BannerProps {
    title: string
    desc?: string
    content?: string
    bgUrl?: string
    theme?: 'light' | 'dark'
    centered?: boolean
    hasPadding?: boolean
    transparent?: boolean
    boxClass?: string
    separatorClass?: string
  }

  const props = withDefaults(defineProps<BannerProps>(), {
    /** 大标题 */
    title: '',
    /** 副标题 */
    desc: '',
    /** 正文 */
    content: '',
    /** 背景图地址 */
    bgUrl: '',
    /** 文字颜色主题 */
    theme: 'dark',
    /** 是否始终居中文字 */
    centered: true,
    /** 是否自带内间距 */
    hasPadding: true,
    /** 是否背景透明 */
    transparent: true,
    /** 容器样式 */
    boxClass: '',
    /** 分隔线样式 */
    separatorClass: 'bg-primary',
  })
</script>
